export default {
  createSuccess: "¡Estructura creada correctamente!",
  updated: "¡Estructura actualizada!",
  deviceNameEmpty: "El nombre de habitación no puede estar vacío",
  deviceRenamed: "Habitación actualizada",
  changeRoomTitle: "Cambiar habitación",
  addRoomTitle: "Añadir habitación",
  changeRoomCurrentLabel: "Habitación actual",
  changeRoomNewLabel: "Nuevo nombre de habitación",
  changeRoomPlaceholder: "p. ej. 231H",
  changeRoomNoRoom: "Sin habitación",
  changeRoomUnchanged: "Introduzca un nombre distinto para continuar",
  changeRoomConfirm: "Continuar",
  changeRoomRemove: "Quitar habitación",
  adminRenameConfirmTitle: "¿Cambiar habitación?",
  adminRenameConfirmMessage:
    'La habitación «{{name}}» ayuda a los anfitriones a reconocer sus tablets. Cambiarla sin su consentimiento puede generar confusión. Puede continuar si es necesario.',
  roomChangeTitle: "¿Cambiar habitación?",
  roomChangeIntro:
    "Este tablet tiene huéspedes actuales o próximos. Elija qué hacer con ellos.",
  roomChangeNewLabel: "Nueva habitación:",
  roomChangeCurrentHeading: "Huéspedes actuales",
  roomChangeFutureHeading: "Huéspedes próximos",
  roomChangeTransferHelp:
    "Transferir: mantener los huéspedes en este tablet con el nuevo nombre de habitación.",
  roomChangeDiscardHelp:
    "Descartar: finalizar huéspedes actuales (historial conservado) y eliminar próximas estancias.",
  roomChangeTransfer: "Transferir huéspedes",
  roomChangeDiscard: "Descartar ocupación",
  structureLeaveIntro:
    'Desasignar de «{{name}}» limpiará la ocupación activa de este tablet.',
  structureLeaveCurrentHeading:
    "Huéspedes actuales (fin de estancia, se guarda en el historial)",
  structureLeaveFutureHeading: "Huéspedes próximos (se eliminan por completo)",
  structureLeaveCurrentNote:
    "Las estancias actuales terminan ahora y permanecen en el historial de esta estructura.",
  structureLeaveFutureNote:
    "Las estancias próximas se eliminan y no se pueden restaurar.",
  structureLeaveEmpty: "No hay huéspedes actuales ni próximos en este tablet.",
  structureLeaveLoading: "Comprobando huéspedes…",
  credentialsRegenerated: "Credenciales regeneradas",
  createModal: {
    title: "Añadir estructura",
    houseNameLabel: "Nombre de la estructura *",
    houseNamePlaceholder: "p. ej. Villa Sunset",
    addressRequired: "Introduzca la dirección de la estructura.",
    commissionPercentLabel: "Porcentaje del anfitrión por reserva (%)",
    nameRequired: "Introduzca el nombre de la estructura.",
    commissionPercentRange: "Introduzca un porcentaje válido.",
    salesAgent: "Agente comercial (contrato)",
    salesAgentSearchPlaceholder: "Escriba un correo…",
    salesAgentNoResults: "Ningún agente coincide con la búsqueda.",
    salesAgentListEmpty: "No hay agentes disponibles.",
    wizardStep2Lead:
      "Seleccione un agente de la lista, u omita para continuar sin agente.",
    salesAgentCutPercentLabel: "Comisión del agente (%)",
    salesAgentCutRequired:
      "Introduzca la comisión del agente cuando seleccione uno.",
    wizardStep3Lead: "Introduzca la dirección completa de la estructura.",
    wizardNext: "Continuar",
    wizardSkip: "Omitir",
    create: "Crear estructura",
  },
  adminCreate: {
    back: "Volver a estructuras",
    backToHost: "Volver al anfitrión",
  },
  list: {
    openHouse: "Abrir",
    hostIdMissing:
      "No se encontró el ID de host. Inicie sesión como anfitrión.",
    titleAdminNoHosts: "Estructuras",
    subtitleAdminNoHosts:
      "Cree primero un anfitrión; luego podrá añadir estructuras.",
    emptyHosts: "Aún no hay anfitriones. Añádalos en la sección Anfitriones.",
    titleByHost: "Estructuras por anfitrión",
    titleMy: "Mis estructuras",
    subtitleByHost: "Elija un anfitrión y gestione sus estructuras",
    subtitleMy:
      "Consulte las estructuras asignadas a su cuenta y gestione sus tablet",
    hostLabel: "Anfitrión",
    selectHostAria: "Seleccionar anfitrión",
    addHouse: "Añadir estructura",
    emptyTitle: "Aún no hay estructuras",
    emptyDescAdmin: "Añada una estructura para este anfitrión.",
    emptyDescHost: "El staff creará las estructuras en su cuenta.",
    addFirstHouse: "Añadir primera estructura",
    loading: "Cargando estructuras…",
    active: "Activa",
    inactive: "Inactiva",
    commissionRate: "{{percent}}% cuota anfitrión",
    hostOptionLabel: "{{name}} (anfitrión)",
  },
  detail: {
    createdOn: "Creada el {{date}}",
    overview: {
      devices: "Tablets",
      devicesHint: "Asignados a esta estructura",
      devicesOnline_one: "{{count}} en línea",
      devicesOnline_other: "{{count}} en línea",
      guestsNow: "Huéspedes ahora",
      guestsNowHint: "Tablets ocupadas de {{count}}",
      upcoming: "Llegadas en cola",
      upcomingHint: "Estancias futuras en las tablets",
      hostShare: "Cuota host",
      hostShareHint: "En cada reserva hecha desde las tablets de la estructura",
    },
    settings: {
      visibilityTitle: "Visibilidad",
    },
    notFoundMessage:
      "Esta estructura puede haber sido eliminada o no tiene acceso.",
    loading: "Cargando estructura…",
    back: "Volver a estructuras",
    backToHouses: "Volver a estructuras",
    goToPartner: "Ir al partner",
    partnerLabel: "Partner",
    tabs: {
      settings: "Ajustes",
      ariaLabel: "Secciones de configuración de la estructura",
      devices: "Dispositivos",
      devicesHintAdmin:
        "Asigne tablets a esta estructura, vincule lectores de pago y gestione las credenciales de los dispositivos.",
      presences: "Presencias",
    },
    presences: {
      staysTitle: "Estancias",
      segmentCurrent: "En curso ({{count}})",
      segmentUpcoming: "Próximas ({{count}})",
      segmentAria: "Vista de estancias",
      currentHint:
        "Huéspedes asignados actualmente a tablets de esta estructura, según lo registrado por el anfitrión.",
      upcomingHint:
        "Huéspedes con llegada programada en tablets de esta estructura, incluidas estancias importadas desde PDF.",
      historyHeading: "Ocupación histórica",
      historyHint:
        "La ocupación se calcula como tiempo ocupado de dispositivos dividido por la capacidad total de dispositivos en el periodo seleccionado.",
      loadingHistory: "Cargando presencias del periodo…",
      errorConnectionMessage:
        "Compruebe su conexión o permisos e inténtelo de nuevo.",
      errorHistoryTitle: "No se pudieron cargar las presencias del periodo",
      emptyCurrentMessage:
        "Ninguna tablet de esta estructura tiene un huésped activo en este momento.",
      emptyUpcomingMessage:
        "No hay estancias próximas programadas para esta estructura.",
      emptyHistoryMessage:
        "No hay presencias que se solapen con el periodo seleccionado.",
      colDevice: "Dispositivo",
      colNationality: "Nacionalidad",
      colMarketing: "Marketing",
      colGuests: "Huéspedes",
      colContacts: "Contacto",
      copyContactHint: "Clic para copiar",
      guestsWithCount: "{{name}} (x{{count}})",
      childrenBadgeHint: "Hay niños en esta estancia",
      colArrival: "Llegada",
      colDeparture: "Salida",
      colNotes: "Notas",
      notesAria: "Ver notas del huésped",
      colActions: "Acciones",
      editAction: "Editar presencia",
      deleteAction: "Eliminar presencia",
      editModalTitle: "Editar presencia – {{deviceName}}",
      consentMarketing: "Marketing directo",
      consentProfiling: "Perfilado",
      consentThirdParty: "Marketing de terceros",
      consentGrantedHint: "El huésped dio consentimiento para:",
      consentDeniedHint:
        "El huésped no dio ningún consentimiento de marketing.",
      valueUnknown: "—",
      genericGuestName: "Huésped",
      dateFrom: "Desde",
      dateTo: "Hasta",
      applyRange: "Aplicar",
      resetRange: "Últimos 3 meses",
      metricOccupancy: "Ocupación",
      metricOccupancyHint:
        "Ocupación media de tablets en el periodo seleccionado",
      metricDevices: "Dispositivos",
      metricPresences: "Presencias",
      chartHeading: "Ocupación diaria",
      chartAria: "Gráfico de ocupación diaria para el periodo seleccionado",
      periodTableHeading: "Presencias del periodo",
      periodTableHint: "Estancias que se solapan con el periodo seleccionado.",
      currentIndicatorHint: "Esta presencia está activa actualmente.",
      emptyPeriodMessage:
        "No hay presencias que se solapen con el periodo seleccionado.",
    },
    presenceImport: {
      title: "Importar presencias desde PDF",
      adminOnly: "Solo staff",
      barHint:
        "Extrae estancias de un PDF (también escaneado) y revisa los campos obligatorios.",
      open: "Importar PDF",
      hint: "Suba cualquier PDF de ocupación: listas de huéspedes, exportaciones PMS o escaneos. Complete los campos obligatorios en blanco y guarde.",
      fileLabel: "Solo PDF",
      dropHint: "Haga clic para elegir un PDF",
      extract: "Extraer estancias",
      save: "Guardar presencias",
      cancel: "Descartar",
      chooseAnother: "Elegir otro PDF",
      addRow: "Añadir estancia",
      previewCount: "{{count}} estancia(s) para revisar",
      colDevice: "Dispositivo",
      colGuest: "Nombre del huésped",
      colNationality: "Nacionalidad",
      colArrival: "Llegada",
      colDeparture: "Salida",
      devicePlaceholder: "Seleccionar dispositivo",
      unmatchedHint: "Del PDF: {{room}}",
      removeRow: "Quitar estancia",
      pickFile: "Elija primero un archivo PDF.",
      emptyPreview:
        "No hay estancias para guardar. Extraiga de nuevo o descarte.",
      toastExtracted:
        "Se extrajeron {{count}} estancia(s). Revise antes de guardar.",
      toastSaved: "Se guardaron {{count}} presencia(s).",
      undo: "Deshacer",
      discardConfirmTitle: "¿Descartar el trabajo?",
      discardConfirmMessage:
        "Si continúa sin guardar, perderá las modificaciones de las estancias extraídas.",
      discardConfirmAction: "Descartar y continuar",
      discardConfirmCancel: "Seguir editando",
      extractingHint: "Analizando el PDF…",
      fileSelectedHint: "PDF seleccionado — haga clic para elegir otro",
      unassignedBanner:
        "{{count}} estancia(s) sin tablet. Asigne cada estancia antes de guardar.",
      unassignedDeviceError: "Asigne un tablet",
      unassignedDeviceTitle: "Sin tablet asignado",
      assignedDeviceTitle: "Tablet asignado",
      scheduleHint: "Horarios por defecto: check-in ~15:00 · check-out ~10:00",
      invalidDateRange: "Salida antes de la llegada",
    },
    visibilityLabel: "Estructura activa",
    visibilityHint:
      "Las estructuras inactivas quedan ocultas en los flujos del anfitrión hasta reactivarlas.",
    visibilityToggleAria: "Activar o desactivar esta estructura",
    devicesTitle: "Dispositivos ({{count}})",
    noDevices: "No hay dispositivos en esta estructura",
    noDevicesHint:
      "El staff puede crear dispositivos en la pestaña Dispositivos y asignarlos aquí.",
    deviceNamePlaceholder: "Nombre de habitación",
    renameDeviceTitle: "Cambiar habitación",
    kioskCode: "Código de dispositivo",
    serialLabel: "N/S",
    currentGuest: "Huésped actual",
    guestDeparts: "sale el {{date}}",
    statusRevoked: "Revocado",
    statusCreated: "Creado",
    statusActive: "Activo",
    regenerateConfirm:
      "¿Regenerar contraseña de «{{name}}»? Las sesiones del tablet existentes dejarán de ser válidas.",
    credentialModalTitle: "Credenciales regeneradas",
    credentialModalDesc:
      "La contraseña se ha regenerado. Guarde estas credenciales ahora: la contraseña solo se muestra una vez.",
    managePresences: "Gestionar huéspedes",
    addPresences: "Añadir huéspedes",
    noGuestPresence: "Ningún huésped registrado",
    queuedGuests: "{{count}} en cola",
    queuedGuests_one: "1 en cola",
    noCurrentGuestWithQueue: "Sin huésped actual · {{count}} en cola",
    noCurrentGuestWithQueue_one: "Sin huésped actual · 1 en cola",
    refreshCredentials: "Actualizar credenciales",
    refreshingCredentials: "Actualizando…",
    hostDevicesCaption:
      "Los códigos de acceso y los datos del dispositivo los gestiona el staff. Puede poner un nombre a cada tablet, arrastrar para reordenar y registrar huéspedes.",
    dragToReorder: "Arrastrar para reordenar",
    modalHouseName: "Nombre de la estructura",
  },
  adminDetail: {
    houseName: "Nombre de la estructura",
    placeholderHouseName: "p. ej. Villa Playa",
    locationTitle: "Ubicación",
    commissionSettings: "Cuota del anfitrión",
    commissionPct: "Porcentaje del anfitrión por reserva (%)",
    commissionPlaceholder: "p. ej. 5",
    assignDevice: "Asignar dispositivo",
    assignDeviceCta: "Asignar un dispositivo",
    colDevice: "Habitación",
    colSerial: "N/S",
    colGoogleAccount: "Cuenta Google",
    colFreekioskUnlock: "Desbloqueo FK",
    colReader: "Lector",
    colLastTelemetry: "Última telemetría",
    colLastInteraction: "Última interacción",
    colInstalledOn: "Instalado el",
    colAppVersion: "Versión de la app",
    colInUse: "En uso",
    colActions: "Acciones",
    renameDeviceTitle: "Cambiar habitación",
    changeRoomTitle: "Cambiar habitación",
    roomNamePlaceholder: "Nombre de habitación",
    roomNameEmpty: "El nombre de habitación no puede estar vacío",
    editGoogleAccountTitle: "Editar cuenta Google",
    editNotesTitle: "Notas",
    editInstalledOnTitle: "Fecha de instalación",
    insertInstalledOn: "Insertar fecha",
    notesPlaceholder: "Añadir una nota…",
    moreActionsTitle: "Más acciones",
    readerPair: "Vincular",
    readerOpenTitle: "Ir al lector",
    readerUnpairTitle: "Desvincular lector",
    readerUnpairConfirm:
      "¿Desvincular este lector de la tablet? El emparejamiento con SumUp se conserva; los pagos permanecerán desactivados hasta que vuelvas a vincular.",
    readerUnpaired: "Lector desvinculado",
    unassignDeviceTitle: "Desasignar dispositivo",
    menuRegenerateCredentials: "Regenerar credenciales",
    menuRevokeDevice: "Revocar credenciales",
    menuReactivateDevice: "Reactivar credenciales",
    menuManagePresences: "Gestionar huéspedes",
    menuNotes: "Notas",
    menuOtherInfo: "Más información",
    toastAssignSuccess: "¡Dispositivo asignado correctamente!",
    toastUpdateSuccess: "¡Estructura actualizada correctamente!",
    toastReaderUpdated: "Lector actualizado",
    toastDeviceRevoked: "Dispositivo revocado",
    toastDeviceReactivated: "Dispositivo reactivado",
    toastDeviceShelved: "Dispositivo en almacén",
    toastDeviceUnshelved: "Dispositivo de nuevo en uso",
    toastDeviceUnassigned: "Dispositivo desasignado",
    toastDeviceRenamed: "Habitación actualizada",
    toastGoogleAccountUpdated: "Cuenta Google actualizada",
    toastNotesUpdated: "Notas actualizadas",
    toastInstalledOnUpdated: "Fecha de instalación actualizada",
    unassignConfirm: "¿Desasignar «{{name}}» de esta estructura?",
    assignModalTitle: "Asignar dispositivo a la estructura",
    assignModalIntro: "Seleccione un dispositivo para asignar a {{houseName}}:",
    searchDevicesLabel: "Buscar dispositivos",
    filterDevicesPlaceholder: "Nombre, código o serie…",
    searchDevicesPlaceholder:
      "Buscar por habitación, código o número de serie…",
    assignModalNoResultsSearch:
      "No hay dispositivos que coincidan con «{{query}}».",
    assignModalNoResults: "No hay dispositivos disponibles para asignar.",
    assign: "Asignar",
    deviceListMeta: "{{code}} — N/S: {{serial}}",
    otherInfoTitle: "Más datos del dispositivo",
    fieldRoomName: "Habitación",
    fieldKioskCode: "Código de dispositivo",
    fieldSerialNumber: "Número de serie",
    fieldGoogleAccount: "Cuenta Google",
    fieldSoftwareId: "ID de software",
    fieldReaderId: "ID del lector",
    fieldBrand: "Marca",
    fieldDisplayInches: "Pulgadas de pantalla",
    fieldResolution: "Resolución",
    fieldAndroidVersion: "Versión de Android",
    fieldAppVersion: "Versión de la app",
    valueAppVersionUnknown: "Desconocida",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    fieldLastTelemetryReport: "Última telemetría recibida",
    sectionTelemetryData: "Datos de telemetría",
    sectionTelemetryDeviceStatus: "Estado del dispositivo (FreeKiosk)",
    sectionTelemetryGpsLocation: "Ubicación (GPS del dispositivo)",
    valueTelemetryNever: "Nunca",
    valueTelemetryEmpty: "Sin datos por ahora",
    valueUnbound: "Sin vincular",
    valueNotPaired: "Sin vincular",
    telemetryBattery: "Batería",
    telemetryWifi: "Señal WiFi",
    telemetryAudio: "Volumen de audio",
    telemetryStorage: "Almacenamiento usado",
    telemetryMemory: "RAM usada",
    telemetryUnavailable: "-",
    telemetryDataAge: "Datos de {{age}}",
  },
  kioskPresence: {
    modalTitle: "Huéspedes – {{kioskName}}",
    tabletFallback: "Tablet",
    toastAdded: "Huésped registrado",
    toastUpdated: "Huésped actualizado",
    toastDeleted: "Huésped eliminado",
    errorGuestNameRequired: "El nombre del huésped es obligatorio",
    errorNationalityRequired: "La nacionalidad es obligatoria",
    errorDatesRequired: "Las fechas de llegada y salida son obligatorias",
    errorDepartureDateRequired: "La fecha de salida es obligatoria",
    errorDepartureAfterArrival: "La salida debe ser posterior a la llegada",
    deleteConfirm: "¿Eliminar al huésped «{{guestName}}»?",
    replaceCurrentTitle: "¿Finalizar la estancia del huésped actual?",
    replaceCurrentMessage:
      "{{guestName}} está registrado actualmente en esta tablet. Para registrar un nuevo huésped, finalizaremos la estancia actual ahora e iniciaremos la nueva.",
    replaceCurrentConfirm: "Finalizar estancia y registrar nuevo huésped",
    sectionCurrentGuest: "Huésped actual",
    sectionUpcoming: "Nuevo huésped",
    emptyNoCurrentGuest: "Sin huésped actual",
    emptyNoUpcoming: "Ningún huésped registrado",
    ctaAddPresence: "Añadir huésped",
    labelGuestName: "Nombre del huésped",
    labelGuestLastName: "Apellido del huésped",
    labelGuestEmail: "Correo electrónico del huésped",
    labelGuestPhone: "Teléfono del huésped",
    labelNationality: "Nacionalidad",
    labelArrivalDate: "Fecha de llegada",
    labelArrivalTime: "Hora de llegada",
    labelDepartureDate: "Fecha de salida",
    labelDepartureTime: "Hora de partida",
    scheduleLaterArrival: "El huésped llega en otra fecha",
    scheduleLaterArrivalHint:
      "Déjalo desmarcado para registrar desde ahora. Actívalo para poner en cola una estancia futura en esta tablet.",
    labelPeople: "Personas",
    labelChildrenCheckbox: "Niños",
    labelNotes: "Notas",
    childrenBadge: "Niños",
    placeholderGuestName: "p. ej. Mario",
    placeholderGuestLastName: "p. ej. Rossi",
    placeholderGuestEmail: "p. ej. mario.rossi@email.com",
    placeholderGuestPhone: "p. ej. +393331234567",
    placeholderNationality: "p. ej. Italia",
    placeholderNotes: "Notas opcionales...",
    peopleCount_one: "{{count}} persona",
    peopleCount_other: "{{count}} personas",
    buttonAddPresence: "Registrar huésped",
    buttonUpdatePresence: "Actualizar huésped",
    consentSectionTitle: "Formulario de consentimiento",
    consentSectionHint:
      "El correo electrónico y el teléfono solo se guardan si el huésped acepta al menos una de las opciones siguientes.",
    consentMarketing:
      "CONSIENTO el tratamiento de mis datos personales por Guestify Italia S.r.l. para comunicaciones de marketing, boletines y ofertas comerciales.",
    consentProfiling:
      "CONSIENTO el tratamiento de mis datos personales por Guestify Italia S.r.l. para analizar mis preferencias y recibir ofertas y servicios personalizados.",
    consentThirdParty:
      "CONSIENTO la cesión de mis datos personales por Guestify Italia S.r.l. a socios seleccionados con fines de marketing.",
    consentRecordedBadge: "Consentimiento registrado",
  },
} as const;
